
<div class="modal-dialog" style="max-width: 600px;">
  <div class="modal-content">
    <form #siteForm="ngForm">
      <div class="modal-header">
        <h4 class="modal-title">Add/Modify Portico</h4>
        <button class="close" type="button" (click)="cancel()">&times;</button>
      </div>
      <div class="modal-body">
        <error [error]="error"></error>
        <div class="row">
          <div class="form-group col">
            <label class="required" for="id">Portico ID</label>
            <div class="input-group mb-3">
              <input class="form-control" id="id" type="text" placeholder="Search for Portico ID" [(ngModel)]="id" name="id" maxlength="100" required (change)="clearBuildings()">
              <div class="input-group-append">
                <button class="btn btn-outline-primary" type="button" (click)="loadCdfDetails()">Go</button>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="form-group col" *ngIf="selectableBuildings?.length">
            <p>OPTIONAL: Limit CDF import to specific buildings (skip to import all)</p>
            <div class="form-check" *ngFor="let building of selectableBuildings; let i = index">
              <input class="form-check-input" type="checkbox" [name]="&quot;building&quot; + i" [(ngModel)]="building.selected" autoLinkToLabel>
              <label class="form-check-label">{{ building.name || "(empty)" }}</label>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button class="btn" type="button" (click)="remove()" [ngClass]="canSave ? 'btn-outline-danger' : 'btn-outline-secondary'" [disabled]="!canRemove">Remove Portico ID from TMC</button>
        <button class="btn" type="button" (click)="save()" [ngClass]="canSave ? 'btn-primary' : 'btn-outline-secondary'" [disabled]="!canSave">Save</button>
      </div>
    </form>
  </div>
</div>